"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SubLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _labelModule = _interopRequireDefault(require("./label.module.scss"));
var _fieldsize = _interopRequireWildcard(require("./fieldsize"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Styleguide label
// ================

const SubLabel = props => {
  if (_react.default.Children.count(props.children) === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("label", {
    "data-description": true,
    className: (0, _classnames.default)(props.className, {
      [_labelModule.default.SubLabelSmall]: props.size === _fieldsize.default.SMALL,
      [_labelModule.default.SubLabel]: props.size === _fieldsize.default.DEFAULT
    })
  }, props.children);
};
exports.SubLabel = SubLabel;
SubLabel.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  size: _propTypes.default.string
};
SubLabel.defaultProps = {
  ..._fieldsize.fieldSizeDefaultProps
};
const Label = props => {
  if (_react.default.Children.count(props.children) === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _labelModule.default.labelWrapper
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(_labelModule.default.Label, {
      [_labelModule.default.LabelSmall]: props.size === _fieldsize.default.SMALL,
      [_labelModule.default.LabelDefault]: props.size === _fieldsize.default.DEFAULT
    }, props.className),
    htmlFor: props.for,
    onClick: props.onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _labelModule.default.labelContent
  }, props.children)), props.tooltip);
};
Label.propTypes = {
  ..._fieldsize.fieldSizePropTypes,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  for: _propTypes.default.string,
  children: _propTypes.default.any,
  tooltip: _propTypes.default.node
};
Label.defaultProps = {
  ..._fieldsize.fieldSizeDefaultProps
};
var _default = exports.default = Label;